const { cleanCartLine } = require('./cartLineCleaning');

/**
 * The opposite of CartLineSplitter.splitDiscounts()
 * It checks for lines in the cart that have been split up because of quantities of offers/discounts
 * on the line and merges them back together.
 *
 * This modifies the passed in cart.
 *
 * @param {Cart} cart
 */
const mergeDiscountedCartLines = (cart) => {
    /**
     * @type {Object<CartLine>}
     */
    let newItemList = {};

    /**
     * TODO: This is no longer needed because item level field data is now stored on item instances.
     * Check and remove in another task.
     *
     * @type {{originalLineNumber: number, newLineNumber: number, newLineOriginalQuantity: number, addedQuantity: number}[]}
     */
    let mergedLines = [];

    /**
     * If we merge some lines, remember what happened to each thirdPartyRef.
     * It may stay the same if it's still in the cart:
     * { originalThirdPartyRef: originalThirdPartyRef }
     * or it may change to point to the new merged line:
     * { originalThirdPartyRef: newThirdPartyRef }
     *
     * @type {Object<string, string>}
     */
    const thirdPartyRefMapping = {};

    // Iterate over each line in the cart.
    cart.itemList.forEach(
        /**
         * @param {CartLine} line
         */
        (line) => {
            // Get the ID of the line, which consists of all the elements we use to consider a line unique.
            let lineId = line.getID();

            // If this line ID already appears as a key in the newItemList,
            // add to its quantity instead of adding another line.
            if (newItemList.hasOwnProperty(lineId)) {
                // Remember the merged lines so we can move the field data.
                // TODO: This is no longer needed because item level field data is now stored on item instances.
                // Check and remove in another task.
                mergedLines.push({
                    originalLineNumber: line.lineNumber,
                    newLineNumber: newItemList[lineId].lineNumber,
                    newLineOriginalQuantity: newItemList[lineId].quantity,
                    addedQuantity: line.quantity,
                });

                // Add this qty to the original line.
                newItemList[lineId].quantity += line.quantity;
                newItemList[lineId].quantityDisplay += line.quantityDisplay;
                newItemList[lineId].qtyBeforeAdjustment += line.qtyBeforeAdjustment;
                newItemList[lineId].discounts.push(...line.discounts);
                newItemList[lineId].originalOrderLines.push(...line.originalOrderLines);

                // When adding the item instances we need to fix the numbers otherwise we will have duplicate numbers.
                // Renumber the ones being added, starting from the max instance already on the line.
                let maxInstanceOnLine = Math.max(...newItemList[lineId].itemInstances.map((ii) => ii.instance));
                line.itemInstances.forEach((ii, index) => {
                    ii.instance = maxInstanceOnLine + 1 + index;
                });

                newItemList[lineId].itemInstances.push(...line.itemInstances);

                // Remember where this thirdPartyRef has gone.
                thirdPartyRefMapping[line.thirdPartyRef] = newItemList[lineId].thirdPartyRef;
            } else {
                newItemList[lineId] = line;

                // This line is staying as-is, so map its thirdPartyRef to itself.
                thirdPartyRefMapping[line.thirdPartyRef] = line.thirdPartyRef;
            }
        }
    );

    // Update the parentThirdPartyRef values based on the merged lines.
    Object.values(newItemList).forEach((line) => {
        if (line.parentThirdPartyRef) {
            line.parentThirdPartyRef = thirdPartyRefMapping[line.parentThirdPartyRef];
        }
    });

    cart.itemList = Object.values(newItemList);
    cart.itemList.forEach(cleanCartLine);
};

module.exports = mergeDiscountedCartLines;
